module.exports = __webpack_public_path__ + "media/seamin-short.f3bbd688.mp4";